import React from 'react';
import MiningHero from '../../components/User/About/Mininghero';
import StatsMap from '../../components/User/About/Statsmap';
import MiningHistory from '../../components/User/About/Mininghistory';
import SimpleBanner from '../../components/common/SimpleBanner';
import PiAbout from '../../components/User/Home/PiAbout';
import MinemoCTA from '../../components/User/Home/Minemocta ';

const About = () => {
  return (
    <div>
      <SimpleBanner title="About Us" subHeading="Home > About Us" />
     <PiAbout/>
     <MiningHero/>
     <MinemoCTA/>
     <StatsMap/>
     <MiningHistory/>
    </div>
  )
}

export default About
